module.exports = __webpack_public_path__ + "static/img/header.b661d2be.png";